// extracted by mini-css-extract-plugin
export default {"pageWrapper":"style_pageWrapper__lAEQN","errorNumber":"style_errorNumber__opiUD","errorMessage":"style_errorMessage__WpaZU","backHomeLink":"style_backHomeLink__ajBi+"};